import * as React from "react";
import {Link} from "gatsby";
import logoWhiteSVG from '../../../assets/img/dei_logo_white.svg'
import './footer.styles.scss'

const Footer = ()=>(
    <footer className="bg-dark py-4 text-[14px]">
        <div className="container flex flex-row justify-between md:justify-start md:items-center items-end">
            <nav className="flex flex md:flex-row flex-col md:items-center">
                <a className="inline-block p-2" href="https://dei.gr/el" target="_blank" rel="noopener norefferer" >
                    <img width="60" height="60" src={logoWhiteSVG} alt="ΔΕΗ"/>
                    <div className="sr-only">ΔΕΗ Portal</div>
                </a>
                <Link to="/terms-of-use" className="md:ml-6 p-2 text-primary" title='Όροι Συμμετοχής'>
                    Όροι Συμμετοχής
                </Link>
                <Link to="/privacy-policy" className="md:ml-6 p-2 text-primary" title='Πολιτική Απορρήτου'>
                    Πολιτική Απορρήτου
                </Link>
                <Link to="/cookies-policy" className="md:ml-6 p-2 text-primary" title='Πολιτική Cookies'>
                    Πολιτική Cookies
                </Link>
            </nav>
            <span className="md:ml-6 text-white">© ΔΕΗ {new Date().getFullYear()}</span>
        </div>
    </footer>
)
export default Footer
